import { useLayoutEffect, type RefObject } from "react";
import { UNPAID_BANNER_HEIGHT_VAR } from "../../configs/unpaidInvoices.config";

// The banner is fixed, so it leaves the flow: the layout reads this variable to start below it.
export const useReservedBannerHeight = (bannerRef: RefObject<HTMLElement | null>) => {
  useLayoutEffect(() => {
    const banner = bannerRef.current;
    if (!banner) return;

    const root = document.documentElement;
    const reserveHeight = () => root.style.setProperty(UNPAID_BANNER_HEIGHT_VAR, `${banner.offsetHeight}px`);
    reserveHeight();

    const resizeObserver = new ResizeObserver(reserveHeight);
    resizeObserver.observe(banner);

    return () => {
      resizeObserver.disconnect();
      root.style.removeProperty(UNPAID_BANNER_HEIGHT_VAR);
    };
  }, [bannerRef]);
};
